import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

export const AuthN = ({
  accountKey, cardToken, productDescription, lastDigits, authComplete,
  authError, authCancel, authDefault,
}) => {
  const authHandler = (response) => {
    switch (response.status) {
      case 0: // no authentication needed
      case 1: // user completed authentication process
        authComplete();
        break;
      case 100: // there was an error, inspect response.errorCode
        authError();
        break;
      case 101: // Interrupted by user (i.e. User hits Cancel Button)
        authCancel();
        break;
      // case 103: Invalid properties were given, inspect response.message (loggedout)
      case 500: // Network error
      default:
        authDefault();
    }
  };

  useEffect(() => {
    if (global.BROWSER) {
      window.AmexSession.authenticate({
        accountKey,
        accountToken: cardToken,
        actionId: 'DLTN01',
        applicationId: 'DVHS01',
        callback: authHandler,
        cardToken,
        autoClose: true,
        headingClassBg: 'border-b color-text-brand-alt',
        headingClassColor: 'color-text-brand-alt',
        cardProduct: productDescription,
        cardLastDigits: lastDigits,
        showPlaceholder: true,
        useAnimation: true,
        showErrors: true,
      });
    }
  }, []);

  return (
    <div className="flex flex-justify-center" data-testid="loading">
      <div className="progress-circle progress-indeterminate progress-lg" />
    </div>
  );
};

AuthN.propTypes = {
  accountKey: PropTypes.string,
  cardToken: PropTypes.string,
  productDescription: PropTypes.string,
  lastDigits: PropTypes.string,
  authComplete: PropTypes.func.isRequired,
  authError: PropTypes.func.isRequired,
  authCancel: PropTypes.func.isRequired,
  authDefault: PropTypes.func.isRequired,
};

AuthN.defaultProps = {
  accountKey: '',
  cardToken: '',
  productDescription: '',
  lastDigits: '',
};

export default AuthN;
